/**
 * Created by Tiger on 24/02/2022.
 */
import Types from '../../action/types';

let initialLanguage = localStorage.getItem('language') || Intl?.DateTimeFormat?.().resolvedOptions?.()?.locale || navigator.language?.split?.('_')?.[0];

if (initialLanguage.includes('zh')) {
    initialLanguage = 'zh';
} else {
    initialLanguage = 'en';
}

const defaultState = { language: initialLanguage };

export default function onAction(state = defaultState, action) {
    switch (action.type) {
        case Types.LANGUAGE:
            return {
                ...state, language: action.language,
            };
        default:
            return { ...state };
    }
}
